import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { APIURL, TZ } from '../../Global';
import ProgressTrack from './ProgressTrack';
import '../../styles/vendorregistration.css';
import RegistrationDetailsPage from './RegistrationDetailsPage';
import VendorDetailsPage from './VendorDetailsPage';
import VendorTypePage from './VendorTypePage';
import AddressPage from './AddressPage';
import SubmitRegistrationPage from './SubmitRegistrationPage';
import { useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert';
import AccountDetailsPage from './AccountDetailsPage';
import PreviewDetailsPage from './PreviewDetailsPage';
import { useTranslation } from 'react-i18next';
import SubscriptionPage from './SubscriptionPage';
import OtpVerificationPage from './OtpVerificationPage';
import { CiStar } from "react-icons/ci";
import { PiPlant } from "react-icons/pi";
import { PaymentMethod, Currency } from '../../lists/VendorReg';
import { getTranslatedOptions } from '../../lists/VendorReg';
import { professionalsList } from '../../lists/VendorReg';
import { statesByCountry } from '../../lists/CountriesData';

export default function VendorRegistration() {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const alert = useAlert()
  const paymentOptions = getTranslatedOptions(PaymentMethod, t, 'paymentMethods');
  const currencyOptions = getTranslatedOptions(Currency, t, 'currencies');
  const [modalShow, setModalShow] = useState(false)
  const [plansList, setPlansList] = useState([])
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    registrationDetails: {
      name: '',
      admin_name: '',
      user_name: '',
      email: '',
      phone_country: {
        code: 'cr',
        name: 'Costa Rica',
        dialCode: '+506',
        format: '(XXXX) XXXX',
        placeholder: '(8888) 8888',
        length: 8
      },
      emergency_country: {
        code: 'cr',
        name: 'Costa Rica',
        dialCode: '+506',
        format: '(XXXX) XXXX',
        placeholder: '(8888) 8888',
        length: 8
      },
      phone: '',
      emergency_phone: '',
      password: '',
      confirm_password: ''
    },
    vendorType: {
      type: null,
      singleUser: false
    },
    subscriptionType: {
      type: '',
    },
    vendorDetails: {
      accreditation: '',
      reg_number: '',
      delivery_radius: '',
      website: '',
      established_year: '',
      // gst: ''
    },
    address: {
      street: '',
      city: '',
      region: '',
      zip: '',
    },
    accountDetails: {
      accountname: '',
      bankname: '',
      iban: '',
      address: '',
      swift: '',
      currency: '',
      payment_method: '',
      proof: [],
      idCardType: '',
      idCardNo: ''
    },
    verification: {
      phone_verified: false,
      email_verified: false,
    }

  });

  const [errors, setErrors] = useState({
    registrationDetails: {},
    vendorType: {},
    vendorDetails: {},
    address: {},
    accountDetails: {},
    subscriptionType: {},
    preview: {},
    submit: {}
  });

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 7;
  const pageRefs = {
    registrationDetails: useRef(null),
    vendorType: useRef(null),
    vendorDetails: useRef(null),
    address: useRef(null),
    accountDetails: useRef(null),
    submit: useRef(null)
  };
  const fieldRefs = useRef({});
  const icons = [
    <PiPlant />,
    <CiStar />,
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24"><g fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={2}><path strokeLinecap="round" d="M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5a7 7 0 0 1-7 7v0a7 7 0 0 1-7-7zm4 18h6l-3-5z"></path><path d="M5 4H4a2 2 0 0 0-2 2v1.239a4 4 0 0 0 2.128 3.535L5.5 11.5M19 4h1a2 2 0 0 1 2 2v.637a5 5 0 0 1-2.66 4.419l-.84.444"></path></g></svg>
  ];

  // Add this after the imports and before the component function
  const idCardTypes = [
    {
      value: 'CF',
      label: 'CF',
      minLength: 9,
      maxLength: 9,
      pattern: /^[1-9]\d{8}$/,
      description: 'vendorRegistration.idCard.cf_description'
    },
    {
      value: 'CJ',
      label: 'CJ',
      minLength: 10,
      maxLength: 10,
      pattern: /^\d{10}$/,
      description: 'vendorRegistration.idCard.cj_description'
    },
    {
      value: 'DIMEX',
      label: 'DIMEX',
      minLength: 11,
      maxLength: 12,
      pattern: /^[1-9]\d{10,11}$/,
      description: 'vendorRegistration.idCard.dimex_description'
    },
    {
      value: 'NITE',
      label: 'NITE',
      minLength: 10,
      maxLength: 10,
      pattern: /^\d{10}$/,
      description: 'vendorRegistration.idCard.nite_description'
    },
    {
      value: 'PE',
      label: 'PE',
      minLength: 1,
      maxLength: 20,
      pattern: /^[A-Za-z0-9]+$/,
      description: 'vendorRegistration.idCard.pe_description'
    },
    {
      value: 'COF',
      label: 'COF',
      minLength: 0,
      pattern: /^.*$/,
      description: 'vendorRegistration.idCard.cof_description'
    }
  ];

  useEffect(() => {
    // Only fetch if vendor type is selected
    if (formData.vendorType.type) {
      setFormData({
        ...formData,
        subscriptionType: ''
      });
      const spType = formData.vendorType.type !== 'other'
        ? formData.vendorType.type
        : formData.vendorType.professional;

      if (spType) {
        fetchMasterVersions(spType);
      }
    }
  }, [formData.vendorType.type, formData.vendorType.professional]);

  const fetchMasterVersions = (spType) => {
    axios.get(`${APIURL}/api/v1/service-provider/master-versions/?${TZ}&sp_type=${spType}`, {
      headers: {}
    })
      .then(res => {
        if (res.status === 200) {
          const data = res.data;
          const plans = data.flatMap(({ pricing_yearly, pricing, ...rest }, index) => [
            {
              ...rest,
              pricing_yearly,
              icon: icons[index % icons.length]
            },
            {
              ...rest,
              pricing,
              icon: icons[index % icons.length]
            },
          ]);
          setPlansList(plans);
        } else {
          alert.error('Error occurred, try again');
        }
      })
      .catch(err => {
        alert.error('Error fetching plans data');
      });
  };

  const handleCheck = (section, field, value) => {
    const data = field === 'phone'
      ? {
        mobile_number: Number(value),
        code: Number(formData.registrationDetails.phone_country.dialCode)
      }
      : field === 'user_name'
        ? {
          username: value.trim()
        }
        : field === 'accreditation' || field === 'reg_number'
          ? {
            accreditation: field === 'accreditation' ? value.trim() : formData.vendorDetails.accreditation.trim(),
            reg_number: field === 'reg_number' ? value.trim() : formData.vendorDetails.reg_number.trim()
          }
          : {
            [field]: value.trim()
          };

    axios.post(`${APIURL}/api/v1/account/check-user/V2/`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (res.data.status === "success") {
          if (res.data.is_existing_user) {
            if (field === 'accreditation' || field === 'reg_number') {
              setErrors(prevErrors => ({
                ...prevErrors,
                [section]: {
                  ...prevErrors[section],
                  reg_number: `This reg_number is already registered`
                }
              }));
            } else {
              setErrors(prevErrors => ({
                ...prevErrors,
                [section]: {
                  ...prevErrors[section],
                  [field]: `This ${field} is already registered`
                }
              }));
            }
          } else {
            setErrors(prevErrors => {
              const updatedSection = { ...prevErrors[section] };
              delete updatedSection[field];

              return {
                ...prevErrors,
                [section]: updatedSection
              };
            });
          }
        } else {
          setErrors(prevErrors => {
            const updatedSection = { ...prevErrors[section] };
            delete updatedSection[field];

            return {
              ...prevErrors,
              [section]: updatedSection
            };
          });
        }
      })
      .catch(err => {
        console.error("Check failed:", err);
      });
  };

  const checkIdCard = (idCardNo, idCardType) => {
    if (!idCardNo || !idCardType) return;

    const payload = {
      idcard_no: idCardNo,
      idcard_type: idCardType,
      src: 'web',
      timeZone: TZ || 'Asia/Calcutta'
    };

    axios.post(`${APIURL}/api/v1/account/check-id/`, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (res.data.status === "success" && res.data.message === "identity not found") {
          setErrors(prevErrors => ({
            ...prevErrors,
            accountDetails: {
              ...prevErrors.accountDetails,
              idCardNo: null
            }
          }));
        } else {
          setErrors(prevErrors => ({
            ...prevErrors,
            accountDetails: {
              ...prevErrors.accountDetails,
              idCardNo: 'idCardAlreadyExists'
            }
          }));
        }
      })
      .catch(err => {
        console.error("ID card check failed:", err);
        setErrors(prevErrors => ({
          ...prevErrors,
          accountDetails: {
            ...prevErrors.accountDetails,
            idCardNo: 'idCardAlreadyExists'
          }
        }));
      });
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const validFiles = files.filter(file => {
        const fileType = file.type;
        const fileExtension = file.name.split('.').pop().toLowerCase();
        return (
          fileType.startsWith('image/') ||
          fileType === 'application/pdf' ||
          ['jpg', 'jpeg', 'png', 'pdf'].includes(fileExtension)
        );
      });

      if (validFiles.length > 0) {
        updateFormData('accountDetails', 'proof', [
          ...(formData.accountDetails.proof || []),
          ...validFiles
        ]);
      } else {
        alert.error(t('vendorRegistration.errors.invalidFileType'));
      }
    }
  };

  const updateFormData = (section, field, value) => {
    if (value !== ' ') {
      setFormData(prevData => {
        const updatedData = {
          ...prevData,
          [section]: {
            ...prevData[section],
            [field]: value
          }
        };

        if (field === 'phone_country') {
          updatedData.address.region = '';
        }

        // Clear registration number when accreditation is cleared
        if (section === 'vendorDetails' && field === 'accreditation' && !value.trim()) {
          updatedData.vendorDetails.reg_number = '';
        }

        if (field === 'name' || field === 'admin_name') {
          const sanitize = (str) => {
            const firstPart = (str || '').split(' ')[0];
            return firstPart.replace(/[^a-zA-ZÀ-ÿ0-9._-]/g, '');
          };

          const name = sanitize(
            field === 'name' ? value : prevData.registrationDetails?.name || ''
          );

          const adminName = sanitize(
            field === 'admin_name' ? value : prevData.registrationDetails?.admin_name || ''
          );

          if (name && adminName) {
            updatedData.registrationDetails.user_name = `${adminName}@${name}`.toLowerCase();
          } else {
            updatedData.registrationDetails.user_name = ''
          }

          // Trigger username validation when name or admin_name changes
          if (updatedData.registrationDetails.user_name && updatedData.registrationDetails.user_name.length >= 3) {
            setTimeout(() => {
              handleCheck('registrationDetails', 'user_name', updatedData.registrationDetails.user_name);
            }, 100);
          }
        }
        return updatedData;
      });
    }

    setErrors(prevErrors => {
      const updatedSection = { ...prevErrors[section] };
      delete updatedSection[field];

      return {
        ...prevErrors,
        [section]: updatedSection
      };
    });

    // Validate accreditation and registration number dependency
    if (section === 'vendorDetails' && (field === 'accreditation' || field === 'reg_number')) {

      setErrors(prevErrors => {
        const updatedVendorDetails = { ...prevErrors.vendorDetails };
        delete updatedVendorDetails.reg_number;
        return {
          ...prevErrors,
          vendorDetails: updatedVendorDetails
        };
      });
    }

    // Username validation on change - call API for every change
    if (field === 'user_name' && value) {
      if (value.trim().length < 3) {
        setErrors(prevErrors => ({
          ...prevErrors,
          [section]: {
            ...prevErrors[section],
            [field]: 'minLength'
          }
        }));
      } else {
        // Call API for username availability check
        handleCheck(section, field, value);
      }
    }

    // ID Card validation on change
    if (section === 'accountDetails' && field === 'idCardNo' && value) {
      validateIdCardNo(value, formData.accountDetails.idCardType);
    }

    // Also trigger validation when ID card type changes
    if (section === 'accountDetails' && field === 'idCardType' && formData.accountDetails.idCardNo) {
      validateIdCardNo(formData.accountDetails.idCardNo, value);
    }

    // Check registration number when either accreditation or registration number changes
    if (section === 'vendorDetails' && (field === 'accreditation' || field === 'reg_number') && value) {
      // Get the current values - use the new value for the field being updated
      const currentAccreditation = field === 'accreditation' ? value : formData.vendorDetails.accreditation;
      const currentRegNumber = field === 'reg_number' ? value : formData.vendorDetails.reg_number;

      if (currentAccreditation?.trim() && currentRegNumber?.trim()) {
        if (field === 'accreditation') {
          handleCheck('vendorDetails', 'accreditation', currentAccreditation);
        } else {
          handleCheck('vendorDetails', 'reg_number', currentRegNumber);
        }
      }
    }

    if ((field === 'email' && (/\S+@\S+\.\S+/.test(value))) ||
      ((field === 'phone') && (formData.registrationDetails.phone_country.length === value.length)) ||
      (field === 'name')) {
      handleCheck(section, field, value)
    }

    if (field === 'confirm_password' && value !== '') {
      if (formData.registrationDetails.password !== value) {
        setErrors(prevErrors => ({
          ...prevErrors,
          [section]: {
            ...prevErrors[section],
            'confirm_password': `passwordMismatch`
          }
        }));
      }
    } else if (field === 'password' && value !== '') {
      if (formData.registrationDetails.confirm_password !== '' && formData.registrationDetails.confirm_password !== value) {
        setErrors(prevErrors => ({
          ...prevErrors,
          [section]: {
            ...prevErrors[section],
            'confirm_password': `passwordMismatch`
          }
        }));
      } else if (formData.registrationDetails.confirm_password !== '' && formData.registrationDetails.confirm_password === value) {
        setErrors(prevErrors => {
          const updatedSection = { ...prevErrors[section] };
          delete updatedSection['confirm_password'];

          return {
            ...prevErrors,
            [section]: updatedSection
          };
        });
      } if (value.length < 8 || (!/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])/.test(value))) {
        setErrors(prevErrors => ({
          ...prevErrors,
          [section]: {
            ...prevErrors[section],
            'password': `passwordComplexity`
          }
        }));
      }
    } else if (/^(name|admin_name|email|phone|password|confirm_password|city|zip|street)$/.test(field) && value === '') {
      setErrors(prevErrors => ({
        ...prevErrors,
        [section]: {
          ...prevErrors[section],
          [field]: `required`
        }
      }));
    }
  };

  const validateIdCardNo = (value, idCardType) => {
    if (!idCardType) return;

    const idTypeConfig = idCardTypes.find(type => type.value === idCardType);
    if (!idTypeConfig) return;

    let error = null;

    if (value.length < idTypeConfig.minLength) {
      error = 'invalidIdCardLength';
    } else if ((idCardType === 'CF' || idCardType === 'DIMEX') && value.startsWith('0')) {
      error = 'idCardStartsWithZero';
    } else if (idTypeConfig.pattern && !idTypeConfig.pattern.test(value)) {
      error = 'invalidIdCardPattern';
    }

    if (!error && value.length >= idTypeConfig.minLength) {
      checkIdCard(value, idCardType);
    }

    if (error) {
      setErrors(prevErrors => ({
        ...prevErrors,
        accountDetails: {
          ...prevErrors.accountDetails,
          idCardNo: error
        }
      }));
    }
  };

  const handleFieldFocus = (section, field) => {
    setErrors(prevErrors => {
      const updatedSection = { ...prevErrors[section] };
      delete updatedSection[field];

      return {
        ...prevErrors,
        [section]: updatedSection
      };
    });
  };

  const registerFieldRef = (section, field, ref) => {
    if (ref) {
      fieldRefs.current[`${section}-${field}`] = ref;
    }
  };

  const validateSection = (section) => {
    const newErrors = { ...errors };

    if (section === 'registrationDetails') {
      newErrors.registrationDetails = newErrors.registrationDetails || {};
      const rd = formData.registrationDetails;

      if (!rd.name.trim()) {
        newErrors.registrationDetails.name = 'required'
      } else if (rd.name.trim().length < 3) {
        newErrors.registrationDetails.name = 'minLength'
      }

      if (!rd.admin_name.trim()) {
        newErrors.registrationDetails.admin_name = 'required'
      } else if (rd.admin_name.trim().length < 3) {
        newErrors.registrationDetails.admin_name = 'minLength'
      }
      if (!rd.user_name.trim()) {
        newErrors.registrationDetails.user_name = 'required'
      } else if (rd.user_name.trim().length < 3) {
        newErrors.registrationDetails.user_name = 'minLength'
      }

      if (!rd.email.trim()) {
        newErrors.registrationDetails.email = 'required'
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(rd.email)) {
        newErrors.registrationDetails.email = 'invalidEmail'
      }

      if (!rd.phone) {
        newErrors.registrationDetails.phone = 'required'
      } else if (rd.phone.length < (rd.phone_country?.length || 0)) {
        newErrors.registrationDetails.phone = 'invalidPhone'
      }

      if (rd.emergency_phone && rd.emergency_phone.length < (rd.emergency_country_country?.length || 0)) {
        newErrors.registrationDetails.emergency_phone = 'invalidPhone'
      }

      if (!rd.password) {
        newErrors.registrationDetails.password = 'required'
      } else if (rd.password.length < 8 || (!/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])/.test(rd.password))) {
        newErrors.registrationDetails.password = 'passwordComplexity'
      }

      if (!rd.confirm_password) {
        newErrors.registrationDetails.confirm_password = 'required'
      } else if (rd.confirm_password !== rd.password) {
        newErrors.registrationDetails.confirm_password = 'passwordMismatch'
      }

      const hasRealErrors = Object.entries(newErrors.registrationDetails).some(
        ([_, value]) => value && value.trim() !== ''
      );
      if (!hasRealErrors) {
        delete newErrors.registrationDetails;
      }
    }
    else if (section === 'vendorType') {
      newErrors.vendorType = newErrors.vendorType || {};

      if (!formData.vendorType.type || (formData.vendorType.type === 'other' && !formData.vendorType.professional)) {
        newErrors.vendorType.type = 'required'
      }

      const hasRealErrors = Object.entries(newErrors.vendorType).some(
        ([_, value]) => value && value.trim() !== ''
      );
      if (!hasRealErrors) {
        delete newErrors.vendorType;
      }
    }
    else if (section === 'vendorDetails') {
      newErrors.vendorDetails = newErrors.vendorDetails || {};

      if (formData.vendorDetails.website && !formData.vendorDetails.website.match(/^(http|https):\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+([\/?#:].*)?$/)) {
        newErrors.vendorDetails.website = 'invalidWebsite'
      }

      if (formData.vendorDetails.established_year) {
        const yearStr = formData.vendorDetails.established_year;
        if (!/^\d+$/.test(yearStr)) {
          newErrors.vendorDetails.established_year = 'invalidYear'
        } else {
          const year = parseInt(yearStr);
          const currentYear = new Date().getFullYear();
          if (year < 1800 || year > currentYear) {
            newErrors.vendorDetails.established_year = 'invalidYear'
          }
        }
      }

      const hasRealErrors = Object.entries(newErrors.vendorDetails).some(
        ([_, value]) => value && value.trim() !== ''
      );
      if (!hasRealErrors) {
        delete newErrors.vendorDetails;
      }
    }
    else if (section === 'address') {
      newErrors.address = newErrors.address || {};

      if (!formData.address.street.trim()) {
        newErrors.address.street = 'required'
      }

      if (!formData.address.city.trim()) {
        newErrors.address.city = 'required'
      }

      if (!formData.address.region.trim()) {
        newErrors.address.region = 'required'
      }

      if (!formData.address.zip.trim()) {
        newErrors.address.zip = 'required'
      }

      const hasRealErrors = Object.entries(newErrors.address).some(
        ([_, value]) => value && value.trim() !== ''
      );
      if (!hasRealErrors) {
        delete newErrors.address;
      }
    }
    else if (section === 'accountDetails') {
      newErrors.accountDetails = newErrors.accountDetails || {};

      if (formData.accountDetails.idCardNo) {
        const idCardType = formData.accountDetails.idCardType;
        const idTypeConfig = idCardTypes.find(type => type.value === idCardType);

        if (idTypeConfig) {
          if (formData.accountDetails.idCardNo.length < idTypeConfig.minLength) {
            newErrors.accountDetails.idCardNo = 'invalidIdCard';
          }

          if (idTypeConfig.pattern && !idTypeConfig.pattern.test(formData.accountDetails.idCardNo)) {
            newErrors.accountDetails.idCardNo = 'invalidIdCard';
          }

          // Check for starting with zero for CF and DIMEX
          if ((idCardType === 'CF' || idCardType === 'DIMEX') && formData.accountDetails.idCardNo.startsWith('0')) {
            newErrors.accountDetails.idCardNo = 'idCardStartsWithZero';
          }
        }
      }

      const hasRealErrors = Object.entries(newErrors.accountDetails).some(
        ([_, value]) => value && value.trim() !== ''
      );
      if (!hasRealErrors) {
        delete newErrors.accountDetails;
      }
    }
    else if (section === 'subscriptionType') {
      newErrors.subscriptionType = newErrors.subscriptionType || {};

      if (!formData.subscriptionType.type) {
        newErrors.subscriptionType.type = 'required'
      }

      const hasRealErrors = Object.entries(newErrors.subscriptionType).some(
        ([_, value]) => value && value.trim() !== ''
      );
      if (!hasRealErrors) {
        delete newErrors.subscriptionType;
      }
    }
    else if (section === 'subscriptionType') {
      if (newErrors.subscriptionType) {
        const hasRealErrors = Object.entries(newErrors.subscriptionType).some(
          ([_, value]) => value && value.trim() !== ''
        );
        if (!hasRealErrors) {
          delete newErrors.subscriptionType;
        }
      }
    }

    setErrors(newErrors);
    return !newErrors[section];
  };

  const getSectionNameByStep = (step) => {
    switch (step) {
      case 1:
        return 'registrationDetails';
      case 2:
        return 'vendorType';
      case 3:
        return 'vendorDetails';
      case 4:
        return 'address';
      case 5:
        return 'accountDetails';
      case 6:
        return 'subscriptionType';
      case 7:
        return 'previewDetails';
      default:
        return 'registrationDetails';
    }
  };

  const getStepForSection = (section) => {
    switch (section) {
      case 'registrationDetails':
        return 1;
      case 'vendorType':
        return 2;
      case 'vendorDetails':
        return 3;
      case 'address':
        return 4;
      case 'accountDetails':
        return 5;
      case 'subscriptionType':
        return 6;
      case 'previewDetails':
        return 7;
      default:
        return 1;
    }
  };

  const focusOnFirstError = (section) => {
    const sectionErrors = errors[section];
    if (sectionErrors && Object.keys(sectionErrors).length > 0) {
      const firstErrorField = Object.keys(sectionErrors)[0];

      const stepForSection = getStepForSection(section);
      if (currentStep !== stepForSection) {
        setCurrentStep(stepForSection);

        setTimeout(() => {
          if (fieldRefs.current[`${section}-${firstErrorField}`]) {
            fieldRefs.current[`${section}-${firstErrorField}`].focus();
          }
        }, 0);
      } else {
        if (fieldRefs.current[`${section}-${firstErrorField}`]) {
          fieldRefs.current[`${section}-${firstErrorField}`].focus();
        }
      }
    }
  };

  const handleStepNavigation = (step) => {
    if (step < currentStep) {
      setCurrentStep(step);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }

    const currentStepIndex = currentStep;
    const targetStepIndex = step;

    for (let i = currentStepIndex; i < targetStepIndex; i++) {
      const sectionName = getSectionNameByStep(i);
      const isValid = validateSection(sectionName);

      if (!isValid) {
        focusOnFirstError(sectionName);

        if (i !== currentStepIndex) {
          setCurrentStep(i);
        }

        return;
      }
    }

    setCurrentStep(step);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const nextStep = () => {
    const currentSectionName = getSectionNameByStep(currentStep);
    const isValid = validateSection(currentSectionName);

    if (isValid) {
      if (currentStep < totalSteps) {
        setCurrentStep(currentStep + 1);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
    else {
      focusOnFirstError(currentSectionName);
    }
  };

  const previousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  const appendIfValid = (formData, key, value) => {
    if (value !== undefined && value !== null) {
      const trimmedValue = typeof value === 'string' ? value.trim() : value;
      if (trimmedValue !== '' && trimmedValue !== null && trimmedValue !== 0 && trimmedValue !== undefined) {
        formData.append(key, trimmedValue);
      }
    }
  }

  const handleSubmit = async () => {
    setSubmitting(true);
    const sections = ['registrationDetails', 'vendorType', 'vendorDetails', 'address'];
    let formIsValid = true;

    for (const section of sections) {
      const sectionIsValid = validateSection(section);
      if (!sectionIsValid) {
        formIsValid = false;
        focusOnFirstError(section);
        break;
      }
    }
    if (!formIsValid) {
      setSubmitting(false);
      return;
    }

    if (formIsValid) {
      const formDataToSend = new FormData();
      appendIfValid(formDataToSend, 'admin_name', formData.registrationDetails.admin_name);
      appendIfValid(formDataToSend, 'name', formData.registrationDetails.name);
      appendIfValid(formDataToSend, 'username', formData.registrationDetails.user_name);
      appendIfValid(formDataToSend, 'email', formData.registrationDetails.email);
      appendIfValid(formDataToSend, 'location', formData.address.city);
      appendIfValid(formDataToSend, 'street', formData.address.street);
      appendIfValid(formDataToSend, 'state', formData.address.region);
      const mobileNumber = formData.registrationDetails.phone
      appendIfValid(formDataToSend, 'mobile_number', mobileNumber);
      appendIfValid(formDataToSend, 'country_code', Number(formData.registrationDetails.phone_country?.dialCode));
      appendIfValid(formDataToSend, 'country', formData.registrationDetails.phone_country?.name);
      appendIfValid(formDataToSend, 'password', formData.registrationDetails.password);
      appendIfValid(formDataToSend, 'pincode', formData.address.zip);
      const spType = formData.vendorType.type !== 'other'
        ? formData.vendorType.type
        : formData.vendorType.professional;
      appendIfValid(formDataToSend, 'sp_type', spType);
      formData.vendorType.type === "other" && appendIfValid(formDataToSend, 'is_single_user', formData.vendorType.singleUser);
      // appendIfValid(formDataToSend, 'gst', Number(formData.vendorDetails.gst));
      appendIfValid(formDataToSend, 'accreditation', formData.vendorDetails.accreditation);
      appendIfValid(formDataToSend, 'reg_number', formData.vendorDetails.reg_number);
      appendIfValid(formDataToSend, 'delivery_radius', Number(formData.vendorDetails.delivery_radius));
      appendIfValid(formDataToSend, 'website', formData.vendorDetails.website);
      appendIfValid(formDataToSend, 'established_year', Number(formData.vendorDetails.established_year));
      if (formData.registrationDetails.emergency_phone) {
        const emergencyPhone = formData.registrationDetails.emergency_phone;
        appendIfValid(formDataToSend, 'contact_phone', emergencyPhone);
        appendIfValid(formDataToSend, 'contact_code', Number(formData.registrationDetails.emergency_country?.dialCode));
      }
      appendIfValid(formDataToSend, 'idcard_type', formData.accountDetails.idCardType?.trim());
      appendIfValid(formDataToSend, 'idcard_no', formData.accountDetails.idCardNo?.trim());
      const accountDetailsJson = {
        account_name: formData.accountDetails.accountname?.trim(),
        bank_name: formData.accountDetails.bankname?.trim(),
        iban: formData.accountDetails.iban?.trim(),
        address: formData.accountDetails.address?.trim(),
        bic_code: formData.accountDetails.swift?.trim(),
        currency: formData.accountDetails.currency?.value?.trim(),
        payment_method: formData.accountDetails.payment_method?.value?.trim()
      };

      const cleanedAccountDetails = Object.fromEntries(
        Object.entries(accountDetailsJson).filter(([_, value]) =>
          value !== null && value !== undefined && value !== ''
        )
      );

      if (Object.keys(cleanedAccountDetails).length > 0) {
        formDataToSend.append('account_details', JSON.stringify(cleanedAccountDetails));
      }
      const subscriptionType = formData.subscriptionType?.type || {};
      appendIfValid(formDataToSend, 'plan_version', subscriptionType.id);
      appendIfValid(formDataToSend, 'plan_period', subscriptionType.pricing ? 'monthly' : 'yearly');
      if (formData.accountDetails.proof.length > 0) {
        formData.accountDetails.proof.forEach((file) => {
          formDataToSend.append('file', file);
        });
      }
      axios.post(`${APIURL}/api/v1/service-provider/register/?${TZ}`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((res) => {
          if (res.status === 200 && res.data.status === 'success') {
            alert.success(t('vendorRegistration.common.submitted_successfully'));
            navigate('/success');
          } else {
            alert.error(t('vendorRegistration.errors.submissionFailed'));
            setSubmitting(false);
          }
        })
        .catch((error) => {
          // Handle different types of errors
          let errorMessage = 'Submission failed. Please try again.';

          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status === 500) {
              errorMessage = 'Server error. Please try again later.';
            } else if (error.response.data && error.response.data.message) {
              errorMessage = error.response.data.message;
            } else if (error.response.statusText) {
              errorMessage = error.response.statusText;
            }
          } else if (error.request) {
            // The request was made but no response was received
            errorMessage = 'No response from server. Please check your network connection.';
          } else {
            // Something happened in setting up the request that triggered an Error
            errorMessage = error.message || 'Request setup failed.';
          }

          console.error('Submission error:', error);
          alert.error(errorMessage);
          setSubmitting(false);
        });
    }
  }

  return (
    <div className={`vendor-registration-container ${currentStep === 7 && 'reg-preview-container'}`}>
      <div className="registration-header">
        <h1>{t(`vendorRegistration.headers.step${currentStep}`)}</h1>
        <p>{t(`vendorRegistration.descriptions.step${currentStep}`)}</p>
      </div>
      <div className={`registration-page ${currentStep === 7 && 'reg-preview-page'}`}>
        {currentStep < 6 && <ProgressTrack currentStep={currentStep} totalSteps={5} onStepClick={handleStepNavigation} />}

        {currentStep === 1 && (
          <RegistrationDetailsPage
            ref={pageRefs.registrationDetails}
            formData={formData}
            updateFormData={updateFormData}
            errors={errors}
            handleFieldFocus={handleFieldFocus}
            registerFieldRef={(field, ref) => registerFieldRef('registrationDetails', field, ref)}
          />
        )}

        {currentStep === 2 && (
          <VendorTypePage
            ref={pageRefs.vendorType}
            formData={formData}
            updateFormData={updateFormData}
            errors={errors}
            handleFieldFocus={handleFieldFocus}
            professionalsList={professionalsList}
            registerFieldRef={(field, ref) => registerFieldRef('vendorType', field, ref)}
          />
        )}

        {currentStep === 3 && (
          <VendorDetailsPage
            ref={pageRefs.vendorDetails}
            formData={formData}
            updateFormData={updateFormData}
            errors={errors}
            handleFieldFocus={handleFieldFocus}
            registerFieldRef={(field, ref) => registerFieldRef('vendorDetails', field, ref)}
          />
        )}

        {currentStep === 4 && (
          <AddressPage
            ref={pageRefs.address}
            formData={formData}
            updateFormData={updateFormData}
            errors={errors}
            handleFieldFocus={handleFieldFocus}
            statesByCountry={statesByCountry}
            registerFieldRef={(field, ref) => registerFieldRef('address', field, ref)}
          />
        )}
        {currentStep === 5 && (
          <AccountDetailsPage
            ref={pageRefs.accountDetails}
            formData={formData}
            updateFormData={updateFormData}
            handleFileUpload={handleFileUpload}
            errors={errors}
            handleFieldFocus={handleFieldFocus}
            paymentOptions={paymentOptions}
            currencyOptions={currencyOptions}
            registerFieldRef={(field, ref) => registerFieldRef('accountDetails', field, ref)}
            idCardTypes={idCardTypes}
          />
        )}
        {currentStep === 6 && (
          <SubscriptionPage
            ref={pageRefs.subscriptionType}
            formData={formData}
            updateFormData={updateFormData}
            errors={errors}
            handleFieldFocus={handleFieldFocus}
            plansList={plansList}
            registerFieldRef={(field, ref) => registerFieldRef('subscriptionType', field, ref)}
          />
        )}
        {currentStep === 7 && (
          <PreviewDetailsPage
            ref={pageRefs.preview}
            formData={formData}
          />
        )}

        {currentStep === 8 && (
          <SubmitRegistrationPage
            ref={pageRefs.submit}
            onSubmit={() => setModalShow(true)}
            formData={formData}
          />
        )}
      </div>

      <div className="form-actions">
        {(currentStep !== 1 && currentStep !== 7) &&
          <button className="previous-button" onClick={previousStep}>
            {t('vendorRegistration.buttons.previous')}
          </button>
        }
        {currentStep !== 7 &&
          <button className="next-button" onClick={nextStep}>
            {t('vendorRegistration.buttons.next')}
          </button>
        }
        {currentStep === 7 &&
          <>
            <button className="previous-button" onClick={previousStep}>
              {t('vendorRegistration.buttons.previous')}
            </button>
            <button className="submit-button" style={{ cursor: submitting ? 'not-allowed' : 'pointer' }} onClick={() => { !submitting && setModalShow(true) }} disabled={submitting}>
              {t('vendorRegistration.buttons.submit')}
            </button>
          </>
        }
        {modalShow && <OtpVerificationPage
          datas={{
            phone: formData.registrationDetails.phone,
            code: formData.registrationDetails.phone_country.dialCode,
            email: formData.registrationDetails.email
          }}
          onSuccess={handleSubmit}
          onClose={() => { setModalShow(false) }} />
        }

      </div>
    </div>
  );
}